export async function handleAsync<T>(
  promiseFn: () => Promise<T>
): Promise<[Error | null, T | null]> {
  try {
    const result = await promiseFn();
    return [null, result];
  } catch (err) {
    return [err as Error, null];
  }
}
